import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import Button from "react-bootstrap/Button";
import { canNavigateBack } from "@/lib/filters/utils";
import { Link } from "react-router-dom";
/* import QuickLinks from "@/lib/ui/components/quickLinks/index"; */

// base representative components

export const Separator = () => <div className="separator" />;

export const Flex = ({ children }) => (
  <div className={`d-flex`}>{children}</div>
);
export const LeftColumn = ({ children, className }) => (
  <div className={`leftColumn d-none d-md-block ${className}`}>{children}</div>
);
export const RightColumn = ({ children, className = undefined }) => (
  <div className={className ? className + ` rightColumn` : "rightColumn"}>
    {children}
  </div>
);

export const NewTabLink = ({
  href,
  children,
  className,
  isTextOnly = false
}) =>
  isTextOnly ? (
    children
  ) : (
    <a
      className={className || "text-endavo-primary"}
      target="_blank"
      rel="noopener noreferrer"
      href={href}
    >
      {children}
    </a>
  );

export const ConditionalLink = ({ condition, href, children, className }) =>
  condition ? (
    <a href={href} className={className || "text-endavo-primary"}>
      {children}
    </a>
  ) : (
    children
  );

export const Bolder = ({ children }) => (
  <span className="fw-bold">{children}</span>
);

export const Loader = () => <div className="loader"></div>;

export const LoaderWithContainer = () => (
  <div className="position-relative loader-container">
    <Loader />
  </div>
);

// TO-DO Suggest better naming and review styles in default.css to get rid of elementDiv classname when react usage is > 90%
export const AutocompleteValueView = styled.div.attrs((props) => ({
  className: "elementDiv",
  as: props.href ? "a" : "span"
}))`
  &&& {
    padding-right: 10px;
    text-decoration: none !important;
  }
`;

export const DoneButton = ({ to }) => {
  const navigate = useNavigate();
  return (
    <Button size="sm" onClick={() => (to ? navigate(to) : navigate(-1))}>
      Done
    </Button>
  );
};

export const getDoneButtonConfig = (navigate, entityUrl) => ({
  title: "Done",
  onClick: () => navigate(canNavigateBack() ? -1 : `/${entityUrl}`)
});

export const ConditionalRouterLink = ({ children, condition, ...props }) => {
  return !!condition && props.to ? (
    <Link {...props}>{children}</Link>
  ) : (
    <>{children}</>
  );
};

/* export const ListLayout = ({ children }) => (
  <Flex>
    <LeftColumn>
      <QuickLinks />
    </LeftColumn>
    <RightColumn>{children}</RightColumn>
  </Flex>
); */
